import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import CookieBanner from './components/feature/CookieBanner';
import GeoRedirectModal from './components/feature/GeoRedirectModal';
import Navbar from './components/feature/Navbar';
import Footer from './components/feature/Footer';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Navbar />
      <AppRoutes />
      <Footer />
      <GeoRedirectModal />
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
